import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { SmsModule } from '@galaxy/sms';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyPageModule } from '@vendasta/galaxy/page';
import { Observable, map } from 'rxjs';
import { ACCOUNT_GROUP_ID_TOKEN, ConversationService } from '../../../../core/src/index';

@Component({
  selector: 'inbox-sms-configuration',
  standalone: true,
  imports: [CommonModule, SmsModule, GalaxyPageModule, TranslateModule],
  providers: [ConversationService],
  templateUrl: './sms-configuration.component.html',
})
export class SmsConfigurationComponent {
  readonly previousPageRoute$ = this.accountGroupId$.pipe(map((id) => `/account/location/${id}/settings/inbox`));
  constructor(@Inject(ACCOUNT_GROUP_ID_TOKEN) private readonly accountGroupId$: Observable<string>) {}
}
